import { createSlice } from '@reduxjs/toolkit';
import { setSession } from './sessionSlice';

export { default as fetchImageDataById } from '../services/_fetchImageDataById';
export { default as fetchImageIRData } from '../services/_fetchImageIRData';
export { default as fetchImagePreviewsBySearch } from '../services/_fetchImagePreviewsBySearch';
export { default as fetchSidebarData } from '../services/_fetchSidebarData';
export { get_files_from_domain_api as getColumbiaResultsFile } from '../services/work-item/handle-columbia';
export { default as saveUpdatedThermalImage } from '../services/_saveUpdatedThermalImage';
export { _updateImageNameByImageId as updateImageNameByImageId } from '../services/_updateImageNameByImageId';
export { default as setSelectedImage } from '../services/_setSelectedImage';

const imagesSlice = createSlice({
  name: 'images',
  initialState: {
    selectedMonth: null,
    selectedYear: null,
    activeHeader: null,
    activeQuery: null,
    activeChild: null,
    isLoading: true,
    imageList: [],
    activeImageData: {},
    selectedImageIRData: [],
    sidebarDates: [],
    selectedImages: [],
    selectedImageIds: JSON.parse(sessionStorage.getItem('selectedImageIds')) || [],
    temporaryImageIds: [],
    workItemSelectedImages: [],
    wasImageUpdated: false,
    session: {},
  },
  reducers: {
    setActiveSidebar: (state, { payload }) => {
      state.activeHeader = payload.name;
      state.activeQuery = payload.query;
      state.activeChild = payload.child;
      state.selectedYear = payload.year;
      state.selectedMonth = payload.month;
      state.searchId = String(payload.searchId);
      state.sidebarDates = JSON.stringify(payload.sidebarDates);
    },
    setImageList: (state, { payload }) => {
      state.imageList = payload;
    },
    setIsLoading: (state, { payload }) => {
      state.isLoading = payload;
    },
    setActiveImageData: (state, { payload }) => {
      state.activeImageData = payload;
    },
    addSelectedImageIRData: (state, { payload }) => {
      let view = new Uint8Array(payload);
      state.selectedImageIRData = view;
    },
    setSelectedImages: (state, { payload }) => {
      state.selectedImages = payload.data;
    },
    addImageToWorkItem: (state, { payload }) => {
      if (
        !state.workItemSelectedImages.some(
          (image) => image.imageJSON.main.image_id === payload.imageJSON.main.image_id,
        )
      ) {
        state.workItemSelectedImages = [...state.workItemSelectedImages, payload];
      }
    },
    setSelectedImagesForWorkItem: (state, { payload }) => {
      state.workItemSelectedImages = payload;
    },
    setSelectedImageIds: (state, { payload }) => {
      state.selectedImageIds = payload;
      sessionStorage.setItem('selectedImageIds', JSON.stringify(payload));
    },
    setTemporaryImageIds: (state, { payload }) => {
      state.temporaryImageIds = payload;
    },
    clearTemporaryImageIds: (state) => {
      state.temporaryImageIds = [];
    },
    setStatusAndReason: (state, { payload }) => {
      state.activeImageData = payload;
    },
    clearSelectedImages: (state) => {
      state.selectedImageIds = [];
      sessionStorage.setItem('selectedImageIds', JSON.stringify([]));
    },
    setWasImageUpdated: (state, { payload }) => {
      state.wasImageUpdated = payload;
    },
  },
  extraReducers: (builder) => {
    // listens to updates from the session slice
    builder.addCase(setSession, (state, action) => {
      state.session = { ...state.session, ...action.payload };
    });
  },
});

export const {
  setActiveSidebar,
  setIsLoading,
  setImageList,
  setActiveImageData,
  addSelectedImageIRData,
  setSelectedImages,
  setSelectedImageIds,
  setStatusAndReason,
  clearSelectedImages,
  setTemporaryImageIds,
  addImageToWorkItem,
  setSelectedImagesForWorkItem,
  clearTemporaryImageIds,
  setWasImageUpdated,
} = imagesSlice.actions;

export default imagesSlice.reducer;
